import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {LayerDirective} from './layer.directive';
import {WrapperDirective} from './wrapper.directive';
export class ParallaxMousemoveModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [WrapperDirective, LayerDirective],
  exports: [WrapperDirective, LayerDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ParallaxMousemoveModule_tsickle_Closure_declarations() {
/** @type {?} */
ParallaxMousemoveModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ParallaxMousemoveModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
